import React from 'react';

import { CustomizedTypography } from '@components/Customized';

import { Divider } from '@material-ui/core';

import useStyles from './useStyles';

interface Props {
  quotationPrice: number;
  deliveryCost: number;
}

const PurchaseOrderTotalPrice = ({
  quotationPrice = 0,
  deliveryCost = 0
}: Props) => {
  const classes = useStyles();

  const valueOfSupply = Number(quotationPrice);

  const tax = Math.floor(valueOfSupply / 10);

  const amount = valueOfSupply + tax + (deliveryCost ?? 0);

  return (
    <div className={classes.priceBox}>
      <div className="price">
        <CustomizedTypography variant="body1" color="textPrimary">
          공급가액
        </CustomizedTypography>
        <CustomizedTypography
          variant="body1"
          fontWeight="500"
          color="textPrimary"
        >
          {valueOfSupply.toLocaleString('kr')} 원
        </CustomizedTypography>
      </div>

      <div className="price">
        <CustomizedTypography variant="body1" color="textPrimary">
          부가세(10%)
        </CustomizedTypography>
        <CustomizedTypography
          variant="body1"
          color="textPrimary"
          fontWeight="500"
        >
          {tax.toLocaleString('kr')} 원
        </CustomizedTypography>
      </div>

      <div className="price deliveryCost">
        <CustomizedTypography variant="body1" color="textPrimary">
          배송비
        </CustomizedTypography>
        <CustomizedTypography
          variant="body1"
          fontWeight="500"
          color="textPrimary"
        >
          {deliveryCost.toLocaleString('kr')} 원
        </CustomizedTypography>
      </div>

      <Divider className="divider" />

      <div className="amount">
        <CustomizedTypography
          variant="h4"
          color="textPrimary"
          fontWeight="bold"
        >
          총 발주금액
        </CustomizedTypography>
        <CustomizedTypography variant="h4" color="primary" fontWeight="700">
          {amount.toLocaleString('kr')} 원
        </CustomizedTypography>
      </div>
    </div>
  );
};

export default PurchaseOrderTotalPrice;
